"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_94)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_94`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.23999 0H35.76V24H-0.23999V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.23999 0H35.76V2.66667H-0.23999V0ZM-0.23999 5.33333H35.76V8H-0.23999V5.33333ZM-0.23999 10.6667H35.76V13.3333H-0.23999V10.6667ZM-0.23999 16H35.76V18.6667H-0.23999V16ZM-0.23999 21.3333H35.76V24H-0.23999V21.3333Z",
					fill: "#0D5EAF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.23999 0H13.0933V13.3333H-0.23999V0Z",
					fill: "#0D5EAF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.23999 5.33337H13.0933V8.00004H-0.23999V5.33337Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.09338 0H7.76005V13.3333H5.09338V0Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_94`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GRFlag };
